import { useQuery } from '@tanstack/react-query'
import {
    getEditionsList,
    GetEditionsListOptions,
    DataLoaderGlobalParams,
    TogglesReduxState,
} from '@news-mono/web-common'
import {
    isFeatureEnabled,
    toFeatureState,
} from '@west-australian-newspapers/etrigan-feature-toggles-client'

/**
 * Get the latest edition that is toggled on in the config.
 * @Todo: To be removed once editions are served from the API.
 */
export function getLatestOnEditionInConfig(toggles: TogglesReduxState) {
    const currentEditions = ['influence', 'tomorrow', 'leadership']
    return (
        currentEditions.find((edition) => {
            return isFeatureEnabled(
                toFeatureState(toggles),
                `the-nightly-on-${edition}-route`,
                false,
            )
        }) || 'tomorrow'
    )
}

// returns the latest TNO edition
export const useLatestOnEdition = (
    isLatestNightlyOnEnabled: boolean,
    services: DataLoaderGlobalParams,
) => {
    const options: GetEditionsListOptions = {
        paging: {
            page: 1,
            pageSize: 1,
        },
        publication: 'the_nightly_on',
    }

    const { data } = useQuery({
        queryKey: ['get-latest-the-nightly-on-edition', services, options],
        queryFn: () => getEditionsList(services, options),
        enabled: isLatestNightlyOnEnabled,
        staleTime: 1000 * 60,
        cacheTime: 1000 * 60 * 10,
    })

    const latestOnEdition =
        data?.documents && data.documents.length > 0
            ? data.documents[0]
            : undefined

    return {
        latestOnEdition,
    }
}
